import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { Card } from "react-bootstrap"
import { Link } from "react-router-dom"
import { FormattedMessage } from "react-intl"
import { showClientAction } from "../../actions/clientsActions"
import ClientForm from "../../components/forms/ClientForm"
import MaterialIcon from "../../components/elements/MaterialIcon"
import { getCountriesAction } from "../../actions/countriesActions"
import { getIndustriesAction } from "../../actions/industriesActions"

class ClientEditPage extends Component {

	state = {
		itemClientsIndex: -1
	}

	componentDidMount() {

		const { match, history } = this.props

		if (!match.params.id)
			history.push("/clients")

		this.props.showClientAction(match.params.id, this.handleFinish)
		this.props.getCountriesAction({ pageSize: 150, sorted: null, filters: [], page: 1 })
		this.props.getIndustriesAction({ pageSize: 15, sorted: null, filters: [], page: 1 })
	}

	handleFinish = () => {
		const { clients, match, history } = this.props
		const itemClientsIndex = clients.data.findIndex(item => (item.id === parseInt(match.params.id, 10)))
		if (itemClientsIndex === -1)
			history.push("/clients")

		this.setState({ itemClientsIndex })
	}

	render() {
		const { itemClientsIndex } = this.state
		const { clients, match } = this.props
		const clientData = itemClientsIndex !== -1 ? clients.data[itemClientsIndex] : null
		return (
			<div className="client-edit-page private-page">
				<div className="top-actions-row">
					<Link to="/clients" className="btn-primary btn-roundet btn-dropshadow btn btn-sm"><MaterialIcon icon="arrow_back" /><FormattedMessage id="buttons.back_to_client" /></Link>
				</div>
				<Card className="client-card fadeInLoadUp">
					<Card.Body>
						<ClientForm client={clientData} id={match.params.id} />
					</Card.Body>
				</Card>
			</div>
		)
	}

}
ClientEditPage.propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			id: PropTypes.string
		})
	}).isRequired,
	history: PropTypes.shape({
		push: PropTypes.func
	}).isRequired,
	showClientAction: PropTypes.func.isRequired,
	clients: PropTypes.shape({
		isLoading: PropTypes.bool,
		data: PropTypes.array
	}).isRequired,
}
const mapStateToProps = (state) => ({
	clients: state.clients
})
export default connect(mapStateToProps, { showClientAction, getCountriesAction, getIndustriesAction })(ClientEditPage)
